import {DataTableColumn} from "mantine-datatable";
import {ProductFeature} from "../types.ts";
import {I18n} from "@aws-amplify/core";
import {formatTimestamp} from "../../../utils/TableTimestamps.tsx";
import {
    Badge,
    Button,
    Group
} from "@mantine/core";
import {useQueryClient} from "@tanstack/react-query";
import {
    disableRecord,
    enableRecord
} from "../services/ProductFeaturesService.ts";
import {notifySuccess, notifyError} from '../../../components/ServiceNotifications';

export const useTableColumns = () => {
    const queryClient = useQueryClient();

    const handleEnable = async (id: string) => {
        try {
            await enableRecord(id);
            notifySuccess('Product Feature enabled');
            queryClient.invalidateQueries({queryKey: ['product-features']});
        } catch (e) {
            notifyError(e);
        }
    };

    const handleDisable = async (id: string) => {
        try {
            await disableRecord(id);
            notifySuccess('Product Feature disabled');
            queryClient.invalidateQueries({queryKey: ['product-features']});
        } catch (e) {
            notifyError(e);
        }
    };

    const columns: DataTableColumn<ProductFeature>[] = [
        {
            accessor: 'name',
            title: I18n.get('Name'),
            width: '1fr',
            render: (item: ProductFeature) => item.name,
        },
        {
            accessor: 'category',
            title: I18n.get('Category'),
            width: '1fr',
            render: (item: ProductFeature) => item.category,
        },
        {
            accessor: 'status',
            title: I18n.get('Status'),
            width: '120px',
            render: (item: ProductFeature) => (
                <Badge
                    color={item.status === 'Active' ? 'green' : item.status === 'Draft' ? 'yellow' : 'red'}
                    variant="light"
                >
                    {item.status || 'UNKNOWN'}
                </Badge>
            ),
        },
        {
            accessor: 'created',
            title: I18n.get('Created'),
            width: '1fr',
            render: (item: ProductFeature) => formatTimestamp(item.created as string),
        },
        {
            accessor: 'updated',
            title: I18n.get('Last Updated'),
            width: '1fr',
            render: (item: ProductFeature) => item.updated ? formatTimestamp(item.updated as string) : 'n/a',
        },
        {
            accessor: 'actions',
            title: I18n.get('Actions'),
            width: '150px',
            render: (item: ProductFeature) => (
                <Group gap="xs">
                    {(!item.status || item.status === 'Inactive' || item.status === 'Draft') && (
                        <Button size="xs" onClick={() => handleEnable(item.id)}>
                            Enable
                        </Button>
                    )}
                    {item.status === 'Active' && (
                        <Button size="xs" color="red" onClick={() => handleDisable(item.id)}>
                            Disable
                        </Button>
                    )}
                </Group>
            ),
        },

    ];

    return {
        columns,
    }
}